import { Stack } from 'expo-router';

export default function AdminEventsLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
